import React from "react";

import "../styles.scss";
import "../scripts";

import { Box } from "theme-ui";
import {
  getDefaultProps,
  KameleonElement,
  primaryCollectionBlock,
} from "@kameleon-core/lib";
import {
  blockConfig,
  ContentCollectionItem,
} from "./components/content-collection-item";

import blockinfo from "./blockinfo.json";
import defaults from "./defaults.json";
import { ContentCollectionType, layoutOptions } from "./types/prop-types";

export const ContentCollection = primaryCollectionBlock<ContentCollectionType>(
  blockConfig,
  ({ PrimaryBlocks }: ContentCollectionType) => (
    <Box className="primary-content-collection-centered-bg-image-v1">
      <Box className="section_header98">
        <Box className="padding-global">
          <Box className="container-large">
            <Box className="padding-section-large">
              <Box className="header98_component_5rem_gap">
                {PrimaryBlocks?.map((service, i) => (
                  <ContentCollectionItem
                    key={`service-${service.name}-${i}`}
                    {...service}
                  />
                ))}
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  )
);

ContentCollection.defaultProps =
  getDefaultProps<ContentCollectionType>(defaults);

export const Element: KameleonElement = {
  component: ContentCollection,
  blockInfo: blockinfo,
  defaultProps: {
    layoutProps: defaults.layoutProps,
    contentProps: defaults.contentProps,
  },
  layoutOptions,
};
